import(/* webpackMode: "eager" */ "/home/ubuntu/download/698499b3921dc90014baa73e/gemsstore/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/698499b3921dc90014baa73e/gemsstore/src/app/product-detail/components/ProductCareAccordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/698499b3921dc90014baa73e/gemsstore/src/app/product-detail/components/ProductImageCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/698499b3921dc90014baa73e/gemsstore/src/app/product-detail/components/ProductInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/698499b3921dc90014baa73e/gemsstore/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/698499b3921dc90014baa73e/gemsstore/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/698499b3921dc90014baa73e/gemsstore/src/components/ui/AppImage.tsx");
